export const MONEY_ARTICLE_NODE = "moneyArticle";
export const MONEY_ARTICLE_DEFAULTS = { title: "Разбор денег магазина", period: "latest", months: "12" } as const;

/** Only presentation choices belong in the document; data and store scope never do. */
export function normalizeMoneyArticleAttrs(value: unknown) {
  const raw = value && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : {};
  const title = typeof raw.title === "string" ? raw.title.replace(/[\u0000-\u001f\u007f]/g, " ").trim().slice(0, 180) : "";
  return {
    title: title || MONEY_ARTICLE_DEFAULTS.title,
    period: typeof raw.period === "string" && /^\d{4}-(0[1-9]|1[0-2])$/.test(raw.period) ? raw.period : "latest",
    months: raw.months === "3" || raw.months === "6" ? raw.months : "12",
  };
}
